import { useState, type FormEvent } from 'react';
import { reminderTips } from '@/mocks/home';
import { useCountdownTo } from '@/hooks/useCountdownTo';

const channelOptions = ['站内提示', '邮件提醒'];

export default function UpdateReminder() {
  const [channel, setChannel] = useState(channelOptions[0]);
  const [contact, setContact] = useState('');
  const [message, setMessage] = useState('');
  const countdown = useCountdownTo(18, 0);

  const handleDemoSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!contact.trim()) {
      setMessage('先留一个接收方式，到点才叫得到你。');
      return;
    }
    setMessage(`已设为「${channel}」提醒，本页仅做展示，不会真实发送。`);
  };

  return (
    <section id="reminder" className="w-full border-b border-background-200 bg-background-50">
      <div className="mx-auto w-full max-w-[1440px] px-4 py-8 md:px-8 md:py-10">
        <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
          <div className="rounded-lg border border-primary-200 bg-primary-50 p-5 md:p-7 lg:col-span-7">
            <span className="flex h-8 w-fit items-center gap-1.5 rounded-full bg-primary-500 px-3 font-label text-xs font-medium text-background-50 dark:text-foreground-950">
              <i className="ri-notification-3-line" />
              六点更新提醒
            </span>
            <h2 className="mt-4 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
              到点再打开，不刷也不错过
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-700">
              设定一次提醒，六点整新料汇总好之后你会收到一次提示。提醒只包含「今日收录条数」和「是否有反转」，不重复推送。
            </p>

            <form onSubmit={handleDemoSubmit} className="mt-5 flex flex-col gap-3">
              <div className="flex flex-wrap items-center gap-2" role="group" aria-label="选择提醒方式">
                {channelOptions.map((option) => (
                  <button
                    key={option}
                    type="button"
                    onClick={() => {
                      setChannel(option);
                      setMessage('');
                    }}
                    className={`flex h-9 items-center whitespace-nowrap rounded-md px-4 font-label text-sm transition-colors ${
                      channel === option
                        ? 'bg-foreground-950 font-medium text-background-50'
                        : 'border border-background-300 bg-background-50 text-foreground-700 hover:text-foreground-950'
                    }`}
                  >
                    {option}
                  </button>
                ))}
              </div>
              <div className="flex flex-col gap-3 sm:flex-row">
                <label className="flex flex-1 items-center gap-2 rounded-md border border-background-300 bg-background-50 px-3 py-2.5">
                  <i className="ri-at-line text-base text-foreground-500" />
                  <span className="sr-only">接收方式</span>
                  <input
                    type="text"
                    value={contact}
                    onChange={(event) => {
                      setContact(event.target.value);
                      setMessage('');
                    }}
                    placeholder="填写接收方式，例如常用邮箱"
                    className="w-full bg-transparent font-label text-sm text-foreground-950 outline-none placeholder:text-foreground-500"
                  />
                </label>
                <button
                  type="submit"
                  className="flex h-11 items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-primary-500 px-6 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 dark:text-foreground-950"
                >
                  <i className="ri-timer-flash-line" />
                  开启六点提醒
                </button>
              </div>
              {message && (
                <p className="flex items-center gap-1.5 font-label text-xs text-primary-700">
                  <i className="ri-information-line" />
                  {message}
                </p>
              )}
            </form>

            <p className="mt-4 font-label text-[11px] leading-relaxed text-foreground-500">
              本页为展示页面，提醒设置不会真实提交，也不会保存任何输入内容。
            </p>
          </div>

          <div className="flex flex-col gap-4 lg:col-span-5">
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
              <div className="flex items-baseline justify-between">
                <span className="font-label text-xs text-foreground-600">距离下一次六点整</span>
                <span className="font-label text-xs text-foreground-500">每日 18:00</span>
              </div>
              <p className="mt-3 font-heading text-4xl font-bold tabular-nums tracking-tight text-foreground-950">
                {countdown.label}
              </p>
              <div className="mt-5 flex flex-col gap-3">
                {reminderTips.map((tip) => (
                  <p key={tip} className="flex items-start gap-2 text-xs leading-relaxed text-foreground-700">
                    <i className="ri-checkbox-circle-line mt-0.5 text-primary-600" />
                    {tip}
                  </p>
                ))}
              </div>
            </div>
            <div className="rounded-lg border border-background-200 bg-background-100 p-5 md:p-7">
              <h3 className="font-heading text-base font-bold text-foreground-950">关于更新节奏</h3>
              <p className="mt-2 text-xs leading-relaxed text-foreground-600">
                全天持续收录，18:00 做一次集中汇总。若当天出现重大反转，会在六点场之后追加一次「加更」标记，加更内容同样进入时间线，不单独开新页。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}